import { message } from "antd";
import { ThunkDispatch } from "redux-thunk";
import { RootState } from "../../reducers";
import { AnyAction } from "redux";
import { isHasBasicInfo } from "../../../javascripts/generic";
import { actionLogoutSuccess } from "../user";
import i18n from "../../../i18n";
import { StatisticsService } from "../../../api/sennotech/scanner/v2/statistics";
import { url, post } from "../../../javascripts/http";

let statisticsService = new StatisticsService(url, post)

// 导出门店统计数据
export function actionExportStatistics(data) {
    console.log('++',data);
    
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading(i18n.t('creatingExportTask'));
        try {
            const orgId = getState().user.orgId;
            const requestData = {
                organizationId: +orgId,
                ...data
            };
            
            const res = await statisticsService.getStatistics(requestData);

            (() => {
                const link = document.createElement('a');
                link.href = res.statisticsDataCsvUrl;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })();

            message.destroy();
        } catch (error) {
            message.destroy();
            message.error(i18n.t('createExportTaskError'), 3);
            console.error('创建导出任务失败:', error);
        }
    };
}